import { DeterministicWrapperView } from './deterministic-wrapper-view';


/**
 * Deterministic wrapper view for backbone view,
 *  generate deterministic view for input backbone view,
 *  so that it can be used in the deterministic-only packages
 */
export class DeterministicViewForBackBoneView extends DeterministicWrapperView {
  viewFactory({ view }) {
    return view;
  }
}
